function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { slugify } from '@finect/front-utils/slugify';
import { getImageUrl } from '../Image/utils';
import { ARTICLES_WITH_NEW_URL } from '../Articles/utils';
import { isFinectLink } from './utils';
import { NOFOLLOW_URLS, OBSOLETE_URLS, STOREFRONT_REDIRECTS } from './constants';
export var NODE_TYPE = {
  ELEMENT_NODE: 1,
  TEXT_NODE: 3,
  COMMENT_NODE: 8
};
export var INLINE_TAGS = ['area', 'br', 'col', 'embed', 'hr', 'img', 'param', 'source', 'track', 'wbr'];
export var NOT_ALLOWED_TAGS = ['meta', 'link', 'title'];
export var LINK_REL = ['nofollow', 'ugc', 'sponsored', 'noopener', 'noreferrer'];
var headingAttribute = function headingAttribute(node) {
  var textNodes = (node.childNodes || []).filter(function (_ref) {
    var nodeType = _ref.nodeType;
    return NODE_TYPE.TEXT_NODE === nodeType;
  }).map(function (_ref2) {
    var text = _ref2.text;
    return text;
  }).filter(function (text) {
    return text;
  });
  var text = textNodes.join(' ');
  if (text && !node.attributes.hasOwnProperty('id')) {
    return _objectSpread(_objectSpread({}, node.attributes), {}, {
      id: slugify(text)
    });
  }
  return node.attributes;
};
export var CUSTOM_ATTRIBUTES = {
  a: function a(_ref3, options) {
    var attributes = _ref3.attributes;
    var _ref4 = options || {},
      _ref4$flags = _ref4.flags,
      flags = _ref4$flags === void 0 ? [] : _ref4$flags;
    var _ref5 = attributes || {},
      _ref5$href = _ref5.href,
      href = _ref5$href === void 0 ? '#' : _ref5$href,
      _ref5$inactive = _ref5.inactive,
      inactive = _ref5$inactive === void 0 ? false : _ref5$inactive;
    var isLinkToFinect = isFinectLink(href);
    if (inactive !== false || !href.length || isLinkToFinect && OBSOLETE_URLS.some(function (url) {
      return href.includes(url);
    })) {
      return _objectSpread(_objectSpread({}, attributes), {}, {
        href: null
      });
    }
    var cleanHref = isLinkToFinect && href.startsWith('http://') ? href.replace('http://', 'https://') : href;
    var hrefWithoutParamsOrHash = cleanHref.split('?')[0].split('#')[0];
    var isStorefrontRedirect = STOREFRONT_REDIRECTS.find(function (_ref6) {
      var tag = _ref6.tag;
      return hrefWithoutParamsOrHash.endsWith("/invertir/".concat(tag));
    });
    var isArticleWithNewUrl = ARTICLES_WITH_NEW_URL.some(function (url) {
      return href.includes(url);
    });
    var finalHref = isStorefrontRedirect ? isStorefrontRedirect.to : isLinkToFinect && isArticleWithNewUrl ? cleanHref.replace(/\/(grupos|usuario)\/[^/]+/, '') : cleanHref;
    var rel = [];
    if (!isLinkToFinect && !attributes.rel) {
      LINK_REL.forEach(function (relValue) {
        return flags.includes(relValue) && rel.push(relValue);
      });
    }
    if (isLinkToFinect && NOFOLLOW_URLS.some(function (url) {
      return href.includes(url);
    })) {
      rel.push('nofollow');
    }
    return _objectSpread(_objectSpread(_objectSpread({}, attributes), {}, {
      'data-fi-event': 'article-body',
      href: finalHref
    }, rel.length ? {
      rel: rel.join(' ')
    } : {}), !isLinkToFinect ? {
      target: '_blank'
    } : {});
  },
  img: function img(_ref7) {
    var attributes = _ref7.attributes,
      classList = _ref7.classList;
    if (classList.some(function (className) {
      return ['image-right-side', 'image-left-side'].includes(className);
    })) {
      return attributes;
    }
    var _attributes$src = attributes.src,
      originalSrc = _attributes$src === void 0 ? '' : _attributes$src;
    var imageSrc = getImageUrl(originalSrc, {
      width: 666
    });
    return _objectSpread(_objectSpread({}, attributes), {}, {
      src: imageSrc
    });
  },
  h1: headingAttribute,
  h2: headingAttribute,
  h3: headingAttribute,
  h4: headingAttribute,
  h5: headingAttribute,
  h6: headingAttribute
};